"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Loader from "./Loader/Loader";

const SummerCampRedirect = () => {
  const router = useRouter();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const loaderTimeout = setTimeout(() => {
      setShowLoader(true);
    }, 300);
    router.push("/tours");
    return () => clearTimeout(loaderTimeout);
  }, [router]);

  return showLoader ? <Loader /> : null;
};

export default SummerCampRedirect;
